<template>
  <div class="point_index">
    <div v-if="bankAccount">
      <section class="text_center">
        <h2 class="header_underline">銀行・郵便局・ATMで購入<br>(収納代行システム)</h2>

        <p class="text_left">全国の銀行・郵便局やコンビニなどのATMからご入金いただく事でポイントを追加する事ができます。<br><br>※1回につき10万円迄のご入金をお願いいたします。<br>10万1円以上のご入金は反映できませんので、ご注意ください。<br>※ポイント反映まで15分程度お時間いただく事があります。</p>
      </section>
      <section class="text_center">
        <h3>ご入金先口座</h3>
        <table class="table setback white">
          <tr>
            <table class="table white border">
              <tr>
                <th>銀行名</th>
                <td>{{ bankAccount.bank_name }}</td>
              </tr>
              <tr>
                <th>支店名</th>
                <td>{{ bankAccount.branch_name }}</td>
              </tr>
              <tr>
                <th>口座番号</th>
                <td>{{ bankAccount.account }}</td>
              </tr>
              <tr>
                <th>口座名義</th>
                <td>{{ bankAccount.account_holder }}</td>
              </tr>
            </table>
          </tr>
        </table>
        <div class="annotation text_left">
          <h4><v-icon color="font_annotation">mdi-alert-circle-outline</v-icon>ご入金時のご注意</h4>
          <p>
            ご入金を頂く際の「ご依頼人名」欄にはご自分のお名前ではなく下記の「<span class="link_sub--text">会員ID</span>」に変更してご入金ください。
          </p>
        </div>
        <table class="table setback white">
          <tr>
            <th>会員ID</th>
            <td>{{ user.user.id }}</td>
          </tr>
        </table>
        <div class="notice text_left">
          <p>もし依頼人名を変更できなかった場合は、ご入金完了後に下記「お問い合わせ」に必ずご連絡ください。</p>
        </div>
      </section>
      <section class="no_padding text_center">
        <h3>お問い合わせ</h3>
        <div class="point_support">
          <p class="text_left">ご不明点などありましたら下記へお気軽にご連絡ください</p>
          <table class="support_info text_left">
            <tr>
              <th>お電話</th>
              <td>：<span class="telephone_num">{{ info.telephone }}</span></td>
            </tr>
            <tr>
              <th>メール</th>
              <td>：<a :href="`mailto:${settingData.inquiry_mail}?subject=${mailSubject}&amp;body=${mailBody}`" class="link_main--text text-decoration-underline">こちらから</a></td>
            </tr>
          </table>
          <div class="notice text_left">
            <p>お電話でのお問い合わせの際は上記の「会員ID」が必要になりますので、会員IDをお控えの上ご連絡ください。</p>
          </div>
        </div>
      </section>
      <section class="overtime text_center">
        <h3>時間外入金に関して</h3>
        <p class="text_left">
          <span class="emphasis--text">平日15時以降、土日祝祭日</span>の場合のお振り込みに関しては、翌営業日扱いとなります。<br>
          直ぐに鑑定ポイントの反映を希望される会員様は以下の手順で<span class="emphasis--text">振込明細票</span>を携帯電話にてカメラ撮影をし【写メ送信】を行って頂きますと、確認が完了次第、
          <span class="emphasis--text">即時鑑定ポイントを追加</span>させて頂きます。
        </p>
        <p class="text_left">
          ■手順1<br>
          まず、当番組へのお振込明細票を携帯電話のカメラにて撮影して下さい。（※下記例参照）
        </p>
        <p class="photo_example text_left">
          <span class="emphasis--text">▼撮影例</span>
          <img :src="photoExample()" alt="撮影例" />
        </p>
        <p class="text_left">
          ■手順2<br>
          <a :href="`mailto:${settingData.inquiry_mail}?subject=${mailSubjectPhoto}&amp;body=${mailBody}`" class="link_main--text text-decoration-underline">こちら</a>からメール作成を行い、<span class="emphasis--text">明細票の写メを添付</span>して、
          メール本文に会員ID【<span class="emphasis--text">{{ user.user.id }}</span>】を入力し、お送り下さい。
        </p>
        <p class="text_left">
          写メ入金方法を行えば、確認が完了次第、即時鑑定ポイントを追加させて頂きます。
        </p>
        <p class="text_left">
          ※写メの文字が確認しづらい場合、再送をお願いする場合が御座いますので、予めご了承下さい。
        </p>
      </section>
      <section class="add_point text_center">
        <h3>追加ポイント表</h3>

        <table class="table white brown border text_left">
          <tr>
            <th>購入額</th>
            <th>追加ポイント数</th>
          </tr>
          <tr>
            <td>500円</td>
            <td>50pt</td>
          </tr>
          <tr>
            <td>1,500円</td>
            <td>150pt</td>
          </tr>
          <tr>
            <td>3,000円</td>
            <td>300pt</td>
          </tr>
          <tr>
            <td>5,000円</td>
            <td class="caution--text">505pt</td>
          </tr>
          <tr>
            <td>10,000円</td>
            <td class="caution--text">1020pt</td>
          </tr>
          <tr>
          <td>20,000円</td>
          <td class="caution--text">2050pt</td>
          </tr>
          <tr>
            <td>30,000円</td>
            <td class="caution--text">3080pt</td>
          </tr>
          <tr>
            <td>50,000円</td>
            <td class="caution--text">5150pt</td>
          </tr>
          <tr>
            <td>70,000円</td>
            <td class="caution--text">7200pt</td>
          </tr>
          <tr>
            <td>100,000円</td>
            <td class="caution--text">10320pt</td>
          </tr>
        </table>
        <p class="text_left">
          ※上記は通常時の追加ポイントとなります。<br>
          キャンペーン等が適用されると更にお得です。
        </p>
      </section>
    </div>
    <div v-else>
      <section class="suspension text_center">
        <p>準備中</p>
        <p><router-link to="/" class="decoration_link_arrow_blue">トップページへ戻る</router-link></p>
      </section>
    </div>
  </div>
</template>

<script>
import { IMAGE_URL } from '@/common/config'
import { GET_BANK_ACCOUNT } from '@/store/point/actions'

export default {
  name: 'PointBank',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      bankAccount: null,
      settingData: []
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    },
    mailSubject () {
      return `入金問い合わせ[${this.user.user.id}]`
    },
    mailSubjectPhoto () {
      return `写メ入金[${this.user.user.id}]`
    },
    mailBody () {
      return `会員ID：${this.user.user.id}`
    }
  },
  methods: {
    getBankAccount () {
      this.$store.dispatch(GET_BANK_ACCOUNT)
        .then((data) => {
          this.bankAccount = data
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    },
    photoExample () {
      return IMAGE_URL + this.bankAccount.image_token
    },
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getBankAccount()
    this.getDefaultSetting()
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
